






























import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import uuid from 'uuid/v4';

@Component({})
export default class CheckboxWidget extends Vue {

  @Inject() public $validator: any;

  @Prop(String) public title!: string;
  @Prop(String) public text!: string;
  @Prop(String) public inputName!: string;
  @Prop(String) public inputDesc!: string;
  @Prop(Boolean) public initialValue!: boolean;
  @Prop(Boolean) public isRequired!: boolean;
  @Prop(Boolean) public isDisabled!: boolean;
  @Prop(Boolean) public showWarningIcon!: boolean;
  @Prop({ type: String, default: 'payrollForm' }) public formName!: string;
  @Prop(String) public staticInputId!: string;


  private inputModel: boolean = false;
  private inputId: string = '';

  public created() {
    this.inputId = this.staticInputId || 'input' + uuid();
    if (this.formName && !this.staticInputId) {
      this.inputId = this.formName + '.' + this.inputId;
    }
  }

  public mounted() {
    this.inputModel = this.initialValue;
  }

  @Watch('initialValue')
  public onInitialValueChanged() {
    this.inputModel = this.initialValue;
  }

  get validators(): any {
    const validator: any = {};
    if (this.isRequired) {
      validator.required = this.isRequired;
    }
    return validator;
  }

  public onChange(): void {
    this.$emit('checkChanged');
    this.$emit('input', this.inputModel);
  }
}
